import { IState } from '../store';
import { getOfferType, isSuburban } from './offer_type';

export function isCountrysideCardIntegrated(state: IState) {
  const { kp } = state.offerData;
  const offerType = getOfferType(state.offerData.offer);
  const hasKpInfo = !!kp && !!kp.name && !!kp.url && !!kp.villageClass && !!kp.imageUrl && !!kp.counterSet;

  return Boolean(isSuburban(offerType) && hasKpInfo);
}
